import Spinner from "../../../assets/icons/Spinner";
import Message from "../../../i18n/Message";

import "./BuilderReplyLoadingState.scss";

/**
 * Shows a loading state while the AI assistant is processing.
 * Displayed when a message is sent and we're waiting for a response.
 * @param {string} planningProgress - Optional thinking/progress text from the agent
 */
const BuilderReplyLoadingState = ({ planningProgress }) => {
  return (
    <div className="builder_reply_loading">
      <div className="message_header">
        <div className="message_avatar">
          <span className="assistant_icon">AI</span>
        </div>
        <div className="message_role">Assistant</div>
      </div>
      <div className="message_body">
        <div className="loading_content">
          <Spinner size={18} />
          <span className="loading_text">
            {planningProgress ? (
              <span className="planning_progress">{planningProgress}</span>
            ) : (
              <Message id="builder_sending" defaultMessage="Thinking..." />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BuilderReplyLoadingState;
